import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "suggestionList"];
  filter() {
    const q = this.inputTarget.value.toUpperCase();
    if (q.length < 1) {
      this.hide();
      return;
    }

    let showSuggestionsList = false;
    for (const suggestion of this.suggestionListTarget.children) {
      let suggestionHidden = !suggestion.innerText.toUpperCase().includes(q);
      suggestion.hidden = suggestionHidden;
      if (!suggestionHidden) {
        showSuggestionsList = true;
      }
    }
    this.suggestionListTarget.hidden = !showSuggestionsList;
  }

  set(event) {
    this.inputTarget.value = event.target.innerText;
    this.hide();
  }

  hide(e) {
    if (e) {
      /* if called by a data action, the event is set. Delay execution to allow clicks outside */
      setTimeout(this.hide.bind(this), 100);
    } else {
      this.suggestionListTarget.hidden = true;
    }
  }
}
